<template>
  <q-input
    v-if="editing && dataType === 'integer'"
    v-model.number="newValue"
    :rules="rules"
    type="number"
    dense
    filled
    square
    style="max-width: 85px"
    lazy-rules
    @blur="emitNewValue"
    @keyup.enter="emitNewValue"
  />
  <q-input
    v-else-if="editing"
    v-model="newValue"
    :rules="rules"
    dense
    filled
    square
    style="max-width: 70px"
    lazy-rules
    @blur="emitNewValue"
    @keyup.enter="emitNewValue"
  />
  <div v-else :class="{ 'selectable-parent': !disabled }" @click="editMode">
    <slot v-if="value !== null || disabled" />
    <span v-else class="text-grey-7">Edit</span>
    <q-tooltip v-if="!disabled && tooltip">
      {{ tooltip }}
    </q-tooltip>
    <q-icon v-if="!disabled" name="edit" class="selectable-icon" />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default {
  name: 'EditAnything',
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: 'Disable editing'
    },
    dataType: {
      type: String as PropType<'text' | 'integer'>,
      default: 'text',
      description: 'Data type of the value'
    },
    value: {
      type: [String, Number, null] as PropType<string | number | null>,
      required: true,
      description: 'Value to edit'
    },
    tooltip: {
      type: String,
      default: '',
      description: 'Tooltip to show on hover'
    },
    rules: {
      type: Array as PropType<((val: string | number) => boolean | string)[]>,
      default: () => [],
      description: 'Validation rules'
    }
  },
  emits: ['input'],
  data() {
    return {
      editing: false,
      newValue: null as string | number | null
    }
  },
  computed: {},
  created() {
    if (this.dataType === 'integer') {
      if (typeof this.value === 'number') {
        this.newValue = this.value
      } else if (this.value === null) {
        this.newValue = null
      }
    } else {
      this.newValue = this.value
    }
  },
  methods: {
    editMode() {
      if (!this.disabled) {
        this.editing = true
      }
    },
    emitNewValue() {
      this.$emit('input', this.newValue)
      this.editing = false
    }
  }
}
</script>

<style scoped lang="scss">
.selectable-icon {
  display: none;
}

.selectable-parent:hover {
  font-weight: bold;
  cursor: pointer;

  .selectable-icon {
    display: inline-block;
    margin-left: 2px;
  }
}
</style>
